module.exports = __webpack_public_path__ + "img/anchor2.f5da9f74.jpg";